







































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import HeaderInfo from './HeaderInfo.vue';

@Component({
  components: {
    HeaderInfo
  }
})
export default class AppDocsComponent extends Vue {
  @Prop() appInfo: any;
  headers = [];
  documents = [];
  search: string = '';

  mounted() {
    this.headers = _app.docListHeaders;
    this.headers.map(x => {
      x.text = this.$t(x.text);
    });

    if (this.appInfo.ConceptNoteId) {
      this.$services.document.listDocs(_app.menu.conceptNote, this.appInfo.ConceptNoteId)
        .then((resp: any) => {
          if (resp.Result === 'OK') {
            this.documents = resp.Record;
          }
        });
    } else {
      this.$services.document.listDocs(_app.menu.application, this.appInfo.ApplicationId)
        .then((resp: any) => {
          if (resp.Result === 'OK') {
            this.documents = resp.Record;
          }
        });
    }
  }

  /** download the file */
  download(doc) {
    this.$services.document.download({
      documentId: doc.DocumentStoreId,
      uploadedFileName: doc.UploadedName
    });
  }
}
